/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  addDecoderSizePrefix,
  addEncoderSizePrefix,
  combineCodec,
  getAddressDecoder,
  getAddressEncoder,
  getBooleanDecoder,
  getBooleanEncoder,
  getI64Decoder,
  getI64Encoder,
  getStructDecoder,
  getStructEncoder,
  getU32Decoder,
  getU32Encoder,
  getU64Decoder,
  getU64Encoder,
  getUtf8Decoder,
  getUtf8Encoder,
  type Address,
  type Codec,
  type Decoder,
  type Encoder,
} from "@solana/kit";

export type ReputationPaymentRecordedEvent = {
  agent: Address;
  paymentSignature: string;
  amount: bigint;
  responseTimeMs: bigint;
  success: boolean;
  newReputationScore: bigint;
  timestamp: bigint;
};

export type ReputationPaymentRecordedEventArgs = {
  agent: Address;
  paymentSignature: string;
  amount: number | bigint;
  responseTimeMs: number | bigint;
  success: boolean;
  newReputationScore: number | bigint;
  timestamp: number | bigint;
};

export function getReputationPaymentRecordedEventEncoder(): Encoder<ReputationPaymentRecordedEventArgs> {
  return getStructEncoder([
    ["agent", getAddressEncoder()],
    [
      "paymentSignature",
      addEncoderSizePrefix(getUtf8Encoder(), getU32Encoder()),
    ],
    ["amount", getU64Encoder()],
    ["responseTimeMs", getU64Encoder()],
    ["success", getBooleanEncoder()],
    ["newReputationScore", getU64Encoder()],
    ["timestamp", getI64Encoder()],
  ]);
}

export function getReputationPaymentRecordedEventDecoder(): Decoder<ReputationPaymentRecordedEvent> {
  return getStructDecoder([
    ["agent", getAddressDecoder()],
    [
      "paymentSignature",
      addDecoderSizePrefix(getUtf8Decoder(), getU32Decoder()),
    ],
    ["amount", getU64Decoder()],
    ["responseTimeMs", getU64Decoder()],
    ["success", getBooleanDecoder()],
    ["newReputationScore", getU64Decoder()],
    ["timestamp", getI64Decoder()],
  ]);
}

export function getReputationPaymentRecordedEventCodec(): Codec<
  ReputationPaymentRecordedEventArgs,
  ReputationPaymentRecordedEvent
> {
  return combineCodec(
    getReputationPaymentRecordedEventEncoder(),
    getReputationPaymentRecordedEventDecoder(),
  );
}
